export interface CalendarEvent {
  start: string
  end: string
  available: boolean
}

export enum BookingSubject {
  CONSULTATION = "consultation",
  DOC_BRAIN_AI = "doc-brain-ai",
  LANDING_PAGE = "landing-page",
}